module.exports = __webpack_public_path__ + "img/dc2a2364f30d8e8b8103e045e939ec01.fc638eaa.png";